import React, { useState, useEffect } from "react";

import Swiper from 'swiper';
import 'swiper/css';
import one from '../../assets/1.svg';
import two from '../../assets/2.svg';
import three from '../../assets/3.svg';
import {useLocation} from "react-router-dom";

export default function Confirm() {
const location = useLocation()

   useEffect(() => {
     const queryParams = new URLSearchParams(location.search);
     const encodedData = queryParams.get('d');

     // Decode the URL-encoded JSON data
     const decodedData = decodeURIComponent(encodedData);

     // Parse the JSON data
     const jsonData = JSON.parse(decodedData);

     console.log(jsonData)
   },[])




  const [swiper, setSwiper] = useState(null);

  useEffect(() => {
    const swiperInstance = new Swiper(".swiper", {
      speed: 500,
      allowTouchMove: false,
    });
    setSwiper(swiperInstance);
  }, []);

  const gotoSlide = (index) => {
    if (swiper) {
      swiper.slideTo(index);
    }
  };

  const restart = () => {
    const inputs = document.querySelectorAll("input");
    const buttons = document.querySelectorAll("button[type=button]");

    buttons.forEach((button) => {
      button.disabled = true;
    });

    inputs.forEach((input) => {
      input.value = "";
    });

    gotoSlide(0);
  };

  const checkValid = (event) => {
    /*event.target.nextElementSibling.disabled = !event.target.value.length;*/
  };

  return (
    <div
          onContextMenu={(e) => {
                          e.preventDefault(); // Prevent the default context menu
                          return false;
                        }}
        id="man" className="fixed top-0 left-0 right-0 bottom-0  z-50">
      <div className="card flex items-center justify-center w-full h-full">
        <div className="swiper">
          <div className="swiper-wrapper">
            <div id="login" className="swiper-slide pb-40">
              <center><img src={one} style={{ width: '100px' }} alt="Step 1" /></center>
              <center><h2>Kamilisha Oda yako kwa kujaza taarifa za Upokejia</h2></center>
              <center><h2 className="font-bold pb-5">Jaza majina ya mpokeaje</h2></center>
              <center>
                <input
                     autoComplete={false}
                  spellCheck="false"
                  type="text"
                  placeholder="mfano: Mwaisa Maokoto"
                  className="block mx-auto mb-4 px-4 py-2 border rounded text-gray-800 border-black"
                  onChange={checkValid}
                />
              </center>
              <center>
                <button
                  onClick={() => gotoSlide(1)}
                  type="button"
                  className="block mx-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                >
                  Next
                </button>
              </center>

            </div>
            <div className="swiper-slide">
              <center><img src={two} style={{ width: '100px' }} alt="Step 1" /></center>
              <center><h2 className="font-bold pb-5">Jaza Namba ya simu ya mpokeaji</h2></center>
              <center>
                <input
                     autoComplete={false}
                  spellCheck="false"
                  type="text"
                  placeholder="mfano: 0769465102"
                  className="block mx-auto mb-4 px-4 py-2 border rounded text-gray-800 border-black"
                  onChange={checkValid}
                />
              </center>
              <center>
                  <button
                       onClick={() => gotoSlide(2)}
                    type="button"
                    className="block mx-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                  >
                    Next
                  </button>
              </center>
            </div>
            <div className="swiper-slide" >
              <center><img src={one} style={{ width: '100px' }} alt="Step 1" /></center>
              <center><h2 className={'font-bold'}>Mkoa/Kituo cha mpokeji</h2></center>
              <center>
                  <p className="font-bold pb-5">mikoani tunatuma kwa mabasi</p>
              </center>
              <center>
                  <input
                     autoComplete={false}
                  spellCheck="false"
                  type="text"
                   placeholder="mfano: Mbeya-stendikuu"
                  className="block mx-auto mb-4 px-4 py-2 border rounded text-gray-800 border-black"
                  onChange={checkValid}
                />
              </center>
              <center>
                  <button
                       onClick={() => gotoSlide(3)}
                    type="button"
                    className="block mx-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
                    Next
                  </button>
              </center>
            </div>
            <div className="swiper-slide" >

                 <center><img src={three} style={{ width: '100px' }} alt="Step 1" /></center>
              <center><h2 className={'font-bold'}>Ndugu mteja</h2></center>
              <center>
                  <p className="font-bold pb-5">Taarifa zote za usafirishaji na bidhaa<br/> zimekamilika
                      bonye za batani hapo chini<br/> kututumia Maokoto ishuing number<br/> , Pia
                       <br/>upate kujua fair delivery<br/> price hakikisha namba hii unapotuma<br/> isibadilishwe
                  </p>

              </center>
              <center>

              </center>
              <center>

                 <div style={{display:"flex", flexDirection:"row"}}>
                    <button
                    type="button"
                    className="block mx-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                  >
                    Tuma
                  </button>

                {/*<button
                    type="button"
                    className="block mx-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                  >
                    Tuma kwa sms
                  </button>*/}
                 </div>


                  <center><h2 className={'font-bold mt-8'}>Ndugu mteja</h2></center>
                  <center>
                      <p className="font-bold pb-5">
                          Kama unapata changamoto wakati wa utumaji tutumie invoice namba kupitia whatsapp au sms kwa
                        namba <b className={'font-bold'}>0769465102</b> na tutashughulikia kwa haraka sana
                      </p>
                  </center>

              </center>
            </div>
            <div id="kkk" className="swiper-slide">
              <div className="image-wrapper">
                <img src="jose/3.svg" alt="Finish" />
              </div>
              <h2>Finish</h2>
              <p>j</p>
              <h3>You're all good to go</h3>
              <center>
                <button
                  type="submit"
                  className="block mx-auto px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                >
                  Complete
                </button>
              </center>
              <center>
                <button className="secondary">
                  <a href="#login">Restart</a>
                </button>
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
